import { Box, Tab, Tabs } from "@mui/material";
import styled from "styled-components";
import LogoEckenmoorhexen from "../../../assets/images/LogoEckenmoorhexen.png"

export const NavbarContainer = styled(Box)`
  position: fixed;
  top: 0; 
  width: 100%;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center; 
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  box-sizing: border-box;
`;

export const TabContainer = styled(Tabs)`
  display: flex;
  justify-content: center; 
  flex-grow: 1;
  max-width: 80%;
`;

export const UserMenuWrapper = styled.div`
  position: absolute;
  right: 2rem;
  top: 50%;
  transform: translateY(-50%);
`;


export const LogoContainer = styled.div`
    width: 8.5rem;
    height: 5rem;
    background-image: url(${LogoEckenmoorhexen});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
`;

export const StyledTab = styled(Tab)`
  &.Mui-selected {
    border-bottom: 2px solid white;
  }
`;
